export default{
    trabalhador:'',
}